import {runInAction} from 'mobx'
import {useEffect} from 'react'
import {HTMLUtil} from 'yougile-util'
import {Hub} from 'yougile-model'
import {SyncEvents} from '@client/sync-events'
import {globals} from '@extensions/globals-base'
import {useTaskDescription} from '../task-description-store'

type Props = {
  hub: Hub
}

export const useSyncDescription = (props: Props): void => {
  const [state, store] = useTaskDescription()

  useEffect(() => {
    const companyId = globals.getCompanyId()
    const listenerId = SyncEvents.addListener(companyId, props.hub?.id, () => {
      runInAction(() => {
        if (state.edit) {
          return
        }

        const html = HTMLUtil.sanitizeHtml(props.hub?.description || '')
        if (state.content !== html) {
          store.updateContent(html)
        }
      })
    })

    return (): void => {
      SyncEvents.removeListener(listenerId)
    }
  }, [props.hub?.id])
}
